module.exports = __webpack_public_path__ + "static/media/Anytime-F.915f100e.gif";